// Copyright (c) 2016 Deere & Company

import ClaimQuestion from '@deere/cps-it.warranty-model-factory/lib/claim-question';
import t from 'tcomb';

const ClaimQuestions = t.list(ClaimQuestion, 'ClaimQuestion');

export const getDefaultState = () => new ClaimQuestions([]);

export default ClaimQuestions;



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/state/claim-questions.js